export enum CreditSafePortfolioCompanyStatus {
    Active = 'active',
    Disabled = 'disabled',
}
